import { cn } from '@/lib/utils';
import officialLogo from '@/assets/cross-official-logo-crop.png';

export function CrossMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'relative inline-grid shrink-0 place-items-center overflow-visible',
        className,
      )}
      aria-hidden="true"
    >
      <img
        src={officialLogo}
        alt=""
        draggable={false}
        className="h-full w-full select-none object-contain mix-blend-screen"
      />
    </span>
  );
}

export function CrossLogo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="flex items-center gap-2.5">
      <CrossMark className={compact ? 'size-8' : 'size-10'} />
      <span className={cn('font-semibold tracking-[.01em]', compact ? 'text-lg' : 'text-[24px]')}>
        CROSS
      </span>
    </div>
  );
}
